module.exports = __webpack_public_path__ + "static/media/packg3.78fc2853.jpg";